<template>
  <div class="foot">
    数据来源：官方公开信息
  </div>
</template>

<script>

export default {
  components: {},
  computed: {},
  data() {
    return {}
  },
  mounted() {

  },
  created() {
  },
  methods: {}
}
</script>
<style type="text/css">

</style>
<style lang="scss" scoped>
@import "@/styles/variables.scss";

.foot {
  width: 200px;
  right: 10px;
  bottom: 15px;
  position: fixed;
  color: #FFFFFF93;
  font-weight: 400;
  line-height: 24px;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/user/layout/components/Foot.vue